export enum CommandStatus {
    Sent = 0,
    Expired = 1,
    Executed = 2,
    Rejected = 3
}